import React from 'react'
import TextField from '../../../shared/components/fields/textField/TextField';
import {I18n} from 'react-redux-i18n';
import SelectField from "../../../shared/components/fields/selectField/SelectField";

const EntityGeneralForm = ({
    name,
    parent,
    viewMode,
    editMode,
    createMode,
    entityList,
    handleFieldChange,
    handleOnFieldBlur
}) => {
    let parentFieldRefactored = {
        value: parent.value,
        data: [...entityList],
        disabled: false
    };

    if(!createMode && parentFieldRefactored.data.findIndex(e => e.value === parent.value) === -1) {
        parentFieldRefactored.data = [{
            value: parentFieldRefactored.value,
            label: '- - -'
        }];
        parentFieldRefactored.disabled = true;
    }

    return <div id="entity-general-form" className="field-row">
        <div className="row">
            <TextField
                value={name.value}
                label={I18n.t("entities.form.name.label")}
                handleFieldChange={value => handleFieldChange("name", value)}
                handleFieldBlur={() => handleOnFieldBlur("name")}
                themeName="form"
                disabled={viewMode}
                error={name.error}
                width={4}
            />
            <SelectField
                value={parentFieldRefactored.value}
                label={I18n.t("entities.form.parent.label")}
                handleFieldChange={value => handleFieldChange("parent", value)}
                options={parentFieldRefactored.data}
                disabled={viewMode || editMode || parentFieldRefactored.disabled}
                error={parent.error}
                width={4}
            />
        </div>
    </div>
};

export default EntityGeneralForm;